export const EMAIL_SUCCESS_MESSAGE = `Link is sent successfully to user's email.`;
export const RESET_SUCCESS_MESSAGE = `User password has been changed successfully.`;
export const UPDATE_SUCCESS_MESSAGE = `User profile settings has been updated.`;
export const UPDATE_REPORT_MESSAGE = `Mail reports assigned to user successfully`;
export const UPDATE_IMAGE_MESSAGE = `User profile image has been updated.`;
export const CREATE_SUCCESS_MESSAGE = `User account has been created.`;
export const ENABLE_USER_MESSAGE = `User account has been activated.`;
export const DISABLE_USER_MESSAGE = `User account has been deactivated.`;
export const DELETE_USER_MESSAGE = `User account has been deleted.`;
export const UPDATE_GAME_MESSAGE = `Changes saved successfully.`;
export const UPDATE_GAME_CATEGORY_MESSAGE = `Changes saved successfully.`;
export const IMPORT_GAME_MESSAGE = `Games imported successfully.`;
export const BULK_PARTNERS_ASSIGN_MESSAGE = `Assign partners file imported successfully`;
export const BULK_ENABLE_GAMES_MESSAGE = `Enable games file imported successfully`;
